import React, { Component, Children } from 'react'
import styles from './style.module.less'
import { Icon as LegacyIcon } from '@ant-design/compatible'
import { Carousel } from 'hljd'
class Arrow extends Component {
  render() {
    const { type, ...rest } = this.props
    const arrowStyle = {
      width: 40,
      height: 50,
      zIndex: 1
    }
    return (
      <div {...rest} style={arrowStyle}>
        <p className={`${styles.arrow} ${styles[type]}`}>
          <LegacyIcon type={type} />
        </p>
      </div>
    )
  }
}
export default class extends Component {
  static defaultProps = {
    arrows: true,
    initialSlide: 0
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    let { initialSlide } = nextProps
    this.slider.goTo(initialSlide)
  }
  render() {
    const { children, arrows, width, ...settings } = this.props
    const count = Children.count(children)
    return (
      <div className={styles.container} style={{ width }}>
        {count ? (
          <Carousel
            ref={slider => (this.slider = slider)}
            dots
            infinite
            arrows={count === 1 ? false : arrows}
            nextArrow={<Arrow type="right" />}
            prevArrow={<Arrow type="left" />}
            {...settings}
          >
            {children}
          </Carousel>
        ) : null}
      </div>
    )
  }
}
